import { CanvasState, CanvasNode, Exploration } from '@/explore/types';

export const setExplorationCanvas = (exploration: Exploration, state: CanvasState) => ({
  ...exploration,
  view: { ...exploration.view, canvas: state },
});

export const setCanvasNodes = (state?: CanvasState, nodes: CanvasNode[] = []) => ({
  edges: state?.edges ?? [],
  nodes,
});
